import { Button } from '@elotech/components';
import { DynamicForm } from '@elotech/react-components';
import React from 'react';

import { DynamicField } from '../../type/FormularioDinamico';
import { ArquivoHandlers } from './useArquivoHandlers';

interface Props {
  instanciaId: string;
  perguntas: DynamicField[];
  editando: boolean;
  salvando: boolean;
  temRascunho: boolean;
  tokenPromise?: () => Promise<string>;
  arquivo?: ArquivoHandlers;
  onAlternarEdicao: () => void;
  onRascunhoChange: (fields: DynamicField[]) => void;
  onConfirmar: () => void;
}

const PerguntasCustomizadas: React.FC<Props> = ({
  instanciaId,
  perguntas,
  editando,
  salvando,
  temRascunho,
  tokenPromise,
  arquivo,
  onAlternarEdicao,
  onRascunhoChange,
  onConfirmar
}) => (
  <>
    <div style={{ display: 'flow-root' }}>
      {editando && (
        <DynamicForm
          key={`dynamic-form-${instanciaId}`}
          fields={perguntas}
          tokenPromise={tokenPromise}
          fileProcessor={arquivo?.processor}
          fileDownloader={arquivo?.downloader}
          valueChanges={(fields: DynamicField[]) =>
            onRascunhoChange(fields ?? [])
          }
        />
      )}
    </div>
    <div className="mt-xs">
      <Button
        iconPosition="left"
        color={editando ? 'negative' : 'neutral'}
        className="inline mt-xs"
        onClick={onAlternarEdicao}
      >
        <i
          aria-hidden="true"
          className={`fa fa-${editando ? 'times' : 'plus'}`}
        />
        {editando ? 'Cancelar' : 'Gerenciar perguntas customizadas'}
      </Button>
      {editando && (
        <Button
          iconPosition="left"
          color="positive"
          className="inline mt-xs"
          disabled={salvando || !temRascunho}
          onClick={onConfirmar}
        >
          <i aria-hidden="true" className="fa fa-check" />
          Salvar perguntas customizadas
        </Button>
      )}
    </div>
  </>
);

export default PerguntasCustomizadas;
